export const STORAGE_KEY = Object.freeze({
  HOME_INFO: "homeInfo",
  CUSTOMER_INFO: "customerInfo",
  CUSTOMER_ADDRESS: "customerAddress",
  SELECTED_PRODUCT: "selectedProduct",
  LOCATION: "location",
  UTM: "utm",
  STAFF_CODE: "staffCode",
  SME: "smeInfo"
});

export const HOME_INFO_KEY = Object.freeze({
  HOME_STRUCTURE: "home_structure",
  HOME_TYPE: "home_type",
});

export const CC_RESP = new Array(
  { eng: "Success", th: "สำเร็จ" },
  {
    eng: "Card number is required",
    th: "โปรดระบุหมายเลขบัตร",
    usedField: "cardNumber",
  },
  {
    eng: "Card number is invalid",
    th: "หมายเลขบัตรไม่ถูกต้อง",
    usedField: "cardNumber",
  },
  {
    eng: "Expiry month is required",
    th: "โปรดระบุวันหมดอายุ",
    usedField: "expiryMonth",
  },
  {
    eng: "Expiry month must be two numbers",
    th: "เดือนหมดอายุบัตรต้องเป็นเลข 2 ตัว เช่น 01",
    usedField: "expiryMonth",
  },
  {
    eng: "Expiry year is required",
    th: "โปรดระบุปีหมดอายุ",
    usedField: "expiryYear",
  },
  {
    eng: "Expiry year must be four numbers",
    th: "ปีหมดอายุบัตรต้องเป็นเลข 4 ตัว",
    usedField: "expiryYear",
  },
  {
    eng: "Card already expired(year)",
    th: "บัตรของคุณหมดอายุแล้ว",
    usedField: "expiryYear",
  },
  {
    eng: "Card already expired(month)",
    th: "บัตรของคุณหมดอายุแล้ว",
    usedField: "expiryMonth",
  },
  {
    eng: "Expiry month is invalid",
    th: "เดือนหมดอายุบัตรไม่ถูกต้อง",
    usedField: "expiryMonth",
  },
  { eng: "CCV2/CVC2 is invalid", th: "รหัสบัตรไม่ถูกต้อง", usedField: "ccv" }
);

export const AlertTypes = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  NONE:' none',
})

export const ActionType = Object.freeze({
  CLOSE: 'close',
  CONFIRM: 'confirm',
  REFRESH: 'refresh',
})

export const PackageStatusEnum = Object.freeze({
  DRAFT: 0,
  PUBLISHED: 1,
  UNLISTED: 2,
})
